import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isArray, isEmpty, isNotEmpty } from '@partners/utils';
import { IListValidationHandler, TValidatorError } from '../../model';

export function emptyListValidator(args: IListValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;
    const { options$$, query$$, valueProp, keyProp } = args;

    if (invalid) return null;

    const options = options$$();
    const query = query$$();

    if (!isArray(options) || isEmpty(query)) {
      return null;
    }

    const isValid = options?.find((option) => {
      const isKeyInList = option[keyProp] == query;

      if (isNotEmpty(valueProp)) {
        const isValueInList = option[valueProp] == query;
        return isKeyInList || isValueInList;
      }
      return isKeyInList;
    });

    if (!isValid) {
      // Console.logError(`>>>>>>>> empty list validator - INVALID! value: ${value}`);
      const vldResponse: TValidatorError = { emptyList: value };
      return vldResponse;
    }

    // Console.logInfo(`>>>>>>>> empty list validator - VALID! value: ${value}`);
    return null;
  };
}
